import { render } from "./MediaLibrary.vue?vue&type=template&id=1fcbf10b"
import script from "./MediaLibrary.vue?vue&type=script&lang=js"
export * from "./MediaLibrary.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "1fcbf10b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1fcbf10b', script)) {
    api.reload('1fcbf10b', script)
  }
  
  module.hot.accept("./MediaLibrary.vue?vue&type=template&id=1fcbf10b", () => {
    api.rerender('1fcbf10b', render)
  })

}

script.__file = "resources/js/Pages/Media/MediaLibrary.vue"

export default script